var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-paper',{staticClass:"admin-master",attrs:{"round":""}},[(_vm.isShow)?_c('admin-upload-master-form',{attrs:{"customerID":_vm.customerID,"storeID":_vm.storeID,"csv":_vm.csvData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }